module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pp-content__page"
  }, [_c('div', {
    staticClass: "pp-tabs"
  }, [_c('ul', {
    staticClass: "pp-tabs__headers"
  }, [_c('li', {
    staticClass: "pp-tabs__headers__header pp-tabs__headers__header--active"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("\n                        Popular\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/albums"
    }
  }, [_vm._v("\n                        Albums\n                    ")])], 1), _vm._v(" "), (_vm.$root.view != 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                        Tracks\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/new"
    }
  }, [_vm._v("\n                        New\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/composers"
    }
  }, [_vm._v("\n                        Composers\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/ensembles"
    }
  }, [_vm._v("\n                        Ensembles\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/artists"
    }
  }, [_vm._v("\n                        Artists\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/exclusive"
    }
  }, [_vm._v("\n                        Exclusives\n                    ")])], 1), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('li', {
    staticClass: "pp-tabs__headers__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                        Tracks\n                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pp-tabs__content"
  }, [_c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n                        Popular Albums\n                    ")]), _vm._v(" "), (_vm.loadingAlbums) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.albums.length > 0) ? _c('album-grid', {
    attrs: {
      "mobile-horizontal": true,
      "items": _vm.albums,
      "max-rows": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.albums.length > 0) ? _c('div', {
    staticClass: "pp-section__readmore"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/albums"
    }
  }, [_vm._v("\n                            See all albums\n                        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n                        Popular Tracks\n                    ")]), _vm._v(" "), (_vm.loadingTracks) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.tracks.length > 0) ? _c('track-list', {
    attrs: {
      "items": _vm.tracks,
      "max-rows": 5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tracks.length > 0) ? _c('div', {
    staticClass: "pp-section__readmore"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/tracks"
    }
  }, [_vm._v("\n                            See all tracks\n                        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n                        Popular Composers\n                    ")]), _vm._v(" "), (_vm.composers.length > 0) ? _c('artist-grid', {
    attrs: {
      "link-to": "/browse/composers/{id}",
      "items": _vm.composers,
      "mobile-horizontal": true,
      "max-rows": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadingComposers) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.composers.length > 0) ? _c('div', {
    staticClass: "pp-section__readmore"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/composers"
    }
  }, [_vm._v("\n                            See all composers\n                        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n                        Popular Ensembles\n                    ")]), _vm._v(" "), (_vm.ensembles.length > 0) ? _c('artist-grid', {
    attrs: {
      "link-to": "/browse/ensembles/{id}",
      "items": _vm.ensembles,
      "mobile-horizontal": true,
      "max-rows": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadingEnsembles) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.ensembles.length > 0) ? _c('div', {
    staticClass: "pp-section__readmore"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/ensembles"
    }
  }, [_vm._v("\n                            See all ensembles\n                        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n                        Popular Artists\n                    ")]), _vm._v(" "), (_vm.artists.length > 0) ? _c('artist-grid', {
    attrs: {
      "link-to": "/browse/artists/{id}",
      "items": _vm.artists,
      "mobile-horizontal": true,
      "max-rows": 1,
      "use-lastname-placeholder": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadingArtists) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.artists.length > 0) ? _c('div', {
    staticClass: "pp-section__readmore"
  }, [_c('router-link', {
    attrs: {
      "to": "/browse/artists"
    }
  }, [_vm._v("\n                            See all artists\n                        ")])], 1) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-header pp-header--simple pp-header--image-generic"
  }, [_c('div', {
    staticClass: "pp-header__title"
  }, [_vm._v("\n            Pristine Streaming\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-header__content"
  }, [_vm._v("\n            Makes discovering and listening to music enjoyable and exciting\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-206bed6d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Home.vue
// module id = 121
// module chunks = 0 1